import React from "react";

const BridalMakeupInJakkurCustomer = () => {
  return (
    <div className="hairSalonInJakkurCustomer">
      <h5>Client Experiences</h5>
      <p>
        Our brides love the results they achieve with our Bridal Makeup in
        Jakkur services. Here are a few testimonials from satisfied clients:
      </p>
      <div className="hairSalonInJakkurCustomerContent">
        <p>
          <span className="quote">“</span>SCENT Salon made my wedding day even
          more special. The bridal makeup was exactly what I had envisioned. The
          team was professional and made sure everything was perfect. I couldn’t
          have asked for a better experience with Bridal Makeup in Jakkur.{" "}
          <span className="quote">”</span> - <span>Ananya R. </span>
        </p>
        <p>
          <span className="quote">“</span>I was so nervous about my wedding
          makeup, but the team at SCENT put me at ease. The trial session was
          great, and on the day of the wedding, my makeup looked flawless. I got
          so many compliments! Thank you for the amazing Bridal Makeup in Jakkur
          experience.
          <span className="quote">”</span> - <span>John S. </span>
        </p>
      </div>
    </div>
  );
};

export default BridalMakeupInJakkurCustomer;
